import { AdaAction } from '../actions'

const historyCanUndo = () => window.editor?.history && window.editor.history.canUndo()
const historyCanRedo = () => window.editor?.history && window.editor.history.canRedo()

interface UndoRedoArgs {
  direction: 'undo' | 'redo'
}

export async function handleUndoRedo(action: AdaAction) {
  if (window.debugAdaActions) console.log('[Chat] handleUndoRedo', action)

  const args = action.args as UndoRedoArgs

  if (!args.direction || (args.direction !== 'undo' && args.direction !== 'redo')) {
    throw new Error('Direction must be either "undo" or "redo"')
  }

  const isUndo = args.direction === 'undo'

  // Check if the requested operation is available
  if (isUndo && !historyCanUndo()) {
    throw new Error('Undo is not available. There are no actions to undo.')
  }
  if (!isUndo && !historyCanRedo()) {
    throw new Error('Redo is not available. There are no actions to redo.')
  }

  // Execute undo or redo
  try {
    if (isUndo) {
      window.editor.undo()
      if (window.debugAdaActions) console.log('[Chat] Undo executed successfully')
    } else {
      window.editor.redo()
      if (window.debugAdaActions) console.log('[Chat] Redo executed successfully')
    }
  } catch (error: any) {
    console.error(`[Chat] Error executing ${isUndo ? 'undo' : 'redo'}:`, error)
    throw new Error(`Failed to ${isUndo ? 'undo' : 'redo'}: ${error.message || 'Unknown error'}`)
  }
}
